// All translations ported verbatim from the legacy platform.html LANGS object.
// Keep keys identical to the original so we can grep cross-reference.

export type Lang = "fr" | "en" | "es" | "de";

export const LANGS: Record<Lang, Record<string, string>> = {
  fr: {
    nav_stats: "Statistiques",
    nav_settings: "Paramètres",
    nav_integration: "Intégration",
    nav_kb: "Base de connaissances",
    nav_logout: "Déconnexion",
    nav_preview: "Aperçu",
    kb_title: "Base de <em>connaissances</em>",
    kb_subtitle: "Gérez les documents et informations de votre assistant.",
    kb_save: "Enregistrer",
    kb_stat_total: "Documents",
    kb_stat_embedded: "Indexés",
    kb_stat_pending: "En attente",
    kb_stat_failed: "Échoués",
    kb_wc_title: "Synchronisation WooCommerce",
    kb_wc_desc: "Synchronise vos produits depuis WooCommerce vers la base de connaissances.",
    kb_wc_btn: "Synchroniser",
    kb_empty: "Aucun document. Ajoutez votre premier document ci-dessus.",
    kb_filter_all: "Tous",
    kb_filter_policy: "Politique",
    kb_new_doc: "+ Nouveau document",
    kb_search_ph: "Rechercher…",
    kb_label_title: "Titre",
    kb_label_type: "Type de document",
    kb_label_content: "Contenu (Markdown)",
    kb_modal_new: "Nouveau document",
    kb_modal_edit: "Modifier le document",
    kb_doc_create: "Créer",
    kb_status_embedded: "Indexé",
    kb_status_pending: "En attente",
    kb_status_outdated: "Obsolète",
    kb_status_failed: "Échoué",
    kb_locked_content: "Contenu restreint",
    kb_locked_badge: "Protégé",
    kb_delete_title: "Supprimer le document",
    kb_delete_body: "Cette action supprimera aussi les vecteurs Qdrant associés.",
    kb_delete_confirm: "Supprimer",
    kb_delete_ok: "Document supprimé.",
    kb_doc_save_ok: "Document enregistré !",
    stats_title: "Tableau de <em>bord</em>",
    stats_subtitle: "Activité de votre chatbot",
    stat_requests: "Requêtes",
    stat_sessions: "Sessions",
    stat_cache_rate: "Taux de cache",
    stat_avg_latency: "Latence moy.",
    stat_cost: "Coût estimé",
    stat_errors: "Erreurs",
    chart_requests: "Requêtes / heure",
    chart_tokens: "Tokens",
    top_queries: "Top requêtes",
    flush_cache: "Vider le cache",
    recent_errors: "Erreurs récentes",
    clear_errors: "Effacer",
    clear_errors_ok: "Erreurs effacées.",
    clear_errors_err: "Erreur lors de l'effacement.",
    clear_errors_confirm: "Effacer toutes les erreurs récentes ?",
    clear_errors_title: "Effacer les erreurs",
    settings_title: "Para<em>mètres</em>",
    settings_subtitle: "Personnalisez votre chatbot",
    tab_widget: "Widget",
    tab_account: "Compte",
    tab_llm_key: "Clé API LLM",
    widget_appearance: "Apparence",
    bot_name: "Nom du bot",
    position: "Position",
    pos_right: "Bas droite",
    pos_left: "Bas gauche",
    primary_color: "Couleur principale",
    secondary_color: "Couleur secondaire",
    welcome_msg: "Message d'accueil",
    logo_url: "URL du logo",
    widget_icon_url: "URL icône bulle",
    widget_size: "Taille du widget",
    size_small: "Petit",
    size_medium: "Moyen",
    size_large: "Grand",
    widget_language: "Langue du widget",
    placeholder_text: "Placeholder",
    powered_by_label: 'Afficher "Propulsé par AM Solutions"',
    powered_by_desc: "Affiche un lien discret en bas du widget",
    business_info_title: "Infos contextuelles",
    business_info_label: "Infos contextuelles",
    save_btn: "Enregistrer",
    saving: "Enregistrement…",
    saved: "Paramètres sauvegardés !",
    change_password: "Changer le mot de passe",
    current_password: "Mot de passe actuel",
    new_password: "Nouveau mot de passe",
    confirm_password: "Confirmer",
    pwd_mismatch: "Les mots de passe ne correspondent pas.",
    pwd_too_short: "Minimum 8 caractères.",
    pwd_success: "Mot de passe mis à jour !",
    pwd_wrong: "Mot de passe actuel incorrect.",
    llm_key_title: "Clé API LLM",
    llm_key_desc: "Votre clé API pour le modèle de langage.",
    llm_key_not_set: "Non configurée",
    llm_key_ok: "Configurée",
    llm_key_warning: "La clé sera masquée après enregistrement. Conservez-la en lieu sûr.",
    llm_key_new: "Nouvelle clé",
    llm_key_save: "Définir / Mettre à jour",
    llm_key_saved: "Clé API enregistrée !",
    integration_title: "Intégration",
    integration_subtitle: "Intégrez le chatbot à votre site",
    widget_key_title: "Clé widget",
    widget_key_desc: "Identifiant public du widget.",
    widget_key_warning: "Pour révéler la clé complète, confirmez votre mot de passe.",
    reveal_password: "Mot de passe",
    reveal_btn: "Révéler la clé",
    reveal_key: "Révéler la clé",
    reveal_wrong: "Mot de passe incorrect.",
    cancel: "Annuler",
    copy: "Copier",
    hide: "Masquer",
    embed_code_title: "Code d'intégration",
    embed_code_desc: "Collez ce code dans le <head> de votre site.",
    copy_snippet: "Copier le code",
    copied: "Copié !",
    powered_by_full: "Propulsé par AM Solutions",
    widget_locked_notice: "La personnalisation du widget a été désactivée par votre administrateur plateforme. Contactez votre administrateur pour activer cette fonctionnalité.",
    login_brand_sub: "Tableau de bord",
    login_h1_plain: "Analytics & Paramètres",
    login_h1_em_target: "Paramètres",
    login_subtitle: "Accédez à votre espace de gestion.",
    lbl_slug: "Identifiant (slug)",
    lbl_password: "Mot de passe",
    lbl_remember: "Rester connecté",
    login_btn: "Connexion",
    pwd_show: "Afficher le mot de passe",
    pwd_hide: "Masquer le mot de passe",
    forgot_link: "Mot de passe oublié ?",
    forgot_title: "Récupération du mot de passe",
    forgot_desc: "Votre mot de passe est géré par <strong>AM Solutions</strong>, l'administrateur de la plateforme.<br><br>Pour le réinitialiser, contactez l'équipe AM Solutions — un email avec vos nouveaux identifiants vous sera envoyé.",
    forgot_back: "Retour",
    login_error: "Identifiant ou mot de passe incorrect.",
    session_expired: "Session expirée. Veuillez vous reconnecter.",
    error_generic: "Une erreur est survenue.",
    period_24h: "24h",
    period_7d: "7j",
    period_30d: "30j",
    flush_ok: "Cache vidé !",
    flush_err: "Erreur lors du vidage.",
    theme_to_light: "Mode clair",
    theme_to_dark: "Mode sombre",
    powered_by_readonly_note: "Ce paramètre est réservé à l'administrateur plateforme.",
    preview_title: "Aper<em>çu</em>",
    preview_subtitle: "Votre widget tel qu'il apparaît sur votre site",
    preview_reload: "Recharger",
    preview_open_tab: "Nouvel onglet",
  },
  en: {
    nav_stats: "Statistics",
    nav_settings: "Settings",
    nav_integration: "Integration",
    nav_kb: "Knowledge base",
    nav_logout: "Sign out",
    nav_preview: "Preview",
    kb_title: "Knowledge <em>base</em>",
    kb_subtitle: "Manage your assistant's documents and information.",
    kb_save: "Save",
    kb_stat_total: "Documents",
    kb_stat_embedded: "Indexed",
    kb_stat_pending: "Pending",
    kb_stat_failed: "Failed",
    kb_wc_title: "WooCommerce sync",
    kb_wc_desc: "Sync your products from WooCommerce into the knowledge base.",
    kb_wc_btn: "Sync now",
    kb_empty: "No documents yet. Add your first document above.",
    kb_filter_all: "All",
    kb_filter_policy: "Policy",
    kb_new_doc: "+ New document",
    kb_search_ph: "Search…",
    kb_label_title: "Title",
    kb_label_type: "Document type",
    kb_label_content: "Content (Markdown)",
    kb_modal_new: "New document",
    kb_modal_edit: "Edit document",
    kb_doc_create: "Create",
    kb_status_embedded: "Indexed",
    kb_status_pending: "Pending",
    kb_status_outdated: "Outdated",
    kb_status_failed: "Failed",
    kb_locked_content: "Restricted content",
    kb_locked_badge: "Protected",
    kb_delete_title: "Delete document",
    kb_delete_body: "This will also remove the associated Qdrant vectors.",
    kb_delete_confirm: "Delete",
    kb_delete_ok: "Document deleted.",
    kb_doc_save_ok: "Document saved!",
    stats_title: "Dash<em>board</em>",
    stats_subtitle: "Your chatbot activity",
    stat_requests: "Requests",
    stat_sessions: "Sessions",
    stat_cache_rate: "Cache rate",
    stat_avg_latency: "Avg latency",
    stat_cost: "Estimated cost",
    stat_errors: "Errors",
    chart_requests: "Requests / hour",
    chart_tokens: "Tokens",
    top_queries: "Top queries",
    flush_cache: "Flush cache",
    recent_errors: "Recent errors",
    clear_errors: "Clear",
    clear_errors_ok: "Errors cleared.",
    clear_errors_err: "Failed to clear errors.",
    clear_errors_confirm: "Clear all recent errors?",
    clear_errors_title: "Clear errors",
    settings_title: "Set<em>tings</em>",
    settings_subtitle: "Customize your chatbot",
    tab_widget: "Widget",
    tab_account: "Account",
    tab_llm_key: "LLM API Key",
    widget_appearance: "Appearance",
    bot_name: "Bot name",
    position: "Position",
    pos_right: "Bottom right",
    pos_left: "Bottom left",
    primary_color: "Primary color",
    secondary_color: "Secondary color",
    welcome_msg: "Welcome message",
    logo_url: "Logo URL",
    widget_icon_url: "Bubble icon URL",
    widget_size: "Widget size",
    size_small: "Small",
    size_medium: "Medium",
    size_large: "Large",
    widget_language: "Widget language",
    placeholder_text: "Placeholder",
    powered_by_label: 'Show "Powered by AM Solutions"',
    powered_by_desc: "Shows a subtle link at the bottom of the widget",
    business_info_title: "Contextual info",
    business_info_label: "Context info for the bot",
    save_btn: "Save",
    saving: "Saving…",
    saved: "Settings saved!",
    change_password: "Change password",
    current_password: "Current password",
    new_password: "New password",
    confirm_password: "Confirm",
    pwd_mismatch: "Passwords do not match.",
    pwd_too_short: "Minimum 8 characters.",
    pwd_success: "Password updated!",
    pwd_wrong: "Current password is incorrect.",
    llm_key_title: "LLM API Key",
    llm_key_desc: "Your API key for the language model.",
    llm_key_not_set: "Not configured",
    llm_key_ok: "Configured",
    llm_key_warning: "The key will be masked after saving. Keep it safe.",
    llm_key_new: "New key",
    llm_key_save: "Set / Update",
    llm_key_saved: "API key saved!",
    integration_title: "Inte<em>gration</em>",
    integration_subtitle: "Embed the chatbot in your website",
    widget_key_title: "Widget key",
    widget_key_desc: "Public widget identifier.",
    widget_key_warning: "To reveal the full key, confirm your password.",
    reveal_password: "Password",
    reveal_btn: "Reveal key",
    reveal_key: "Reveal key",
    reveal_wrong: "Incorrect password.",
    cancel: "Cancel",
    copy: "Copy",
    hide: "Hide",
    embed_code_title: "Embed code",
    embed_code_desc: "Paste this code in your site's <head>.",
    copy_snippet: "Copy code",
    copied: "Copied!",
    powered_by_full: "Powered by AM Solutions",
    widget_locked_notice: "Widget customization has been disabled by your platform administrator. Contact your administrator to enable this feature.",
    login_brand_sub: "Dashboard",
    login_h1_plain: "Analytics & Settings",
    login_h1_em_target: "Settings",
    login_subtitle: "Access your management space.",
    lbl_slug: "Identifier (slug)",
    lbl_password: "Password",
    lbl_remember: "Stay signed in",
    login_btn: "Sign in",
    pwd_show: "Show password",
    pwd_hide: "Hide password",
    forgot_link: "Forgot password?",
    forgot_title: "Password recovery",
    forgot_desc: "Your password is managed by <strong>AM Solutions</strong>, the platform administrator.<br><br>To reset it, contact the AM Solutions team — you will receive an email with your new credentials.",
    forgot_back: "Back",
    login_error: "Invalid identifier or password.",
    session_expired: "Session expired. Please sign in again.",
    error_generic: "An error occurred.",
    period_24h: "24h",
    period_7d: "7d",
    period_30d: "30d",
    flush_ok: "Cache flushed!",
    flush_err: "Error flushing cache.",
    theme_to_light: "Light mode",
    theme_to_dark: "Dark mode",
    powered_by_readonly_note: "This setting is reserved for the platform administrator.",
    preview_title: "Pre<em>view</em>",
    preview_subtitle: "Your widget as it appears on your site",
    preview_reload: "Reload",
    preview_open_tab: "New tab",
  },
  es: {
    nav_stats: "Estadísticas",
    nav_settings: "Configuración",
    nav_integration: "Integración",
    nav_kb: "Base de conocimientos",
    nav_logout: "Cerrar sesión",
    nav_preview: "Vista previa",
    kb_title: "Base de <em>conocimientos</em>",
    kb_subtitle: "Gestiona los documentos e información de tu asistente.",
    kb_save: "Guardar",
    kb_stat_total: "Documentos",
    kb_stat_embedded: "Indexados",
    kb_stat_pending: "Pendientes",
    kb_stat_failed: "Fallidos",
    kb_wc_title: "Sincronización WooCommerce",
    kb_wc_desc: "Sincroniza tus productos desde WooCommerce a la base de conocimientos.",
    kb_wc_btn: "Sincronizar",
    kb_empty: "Sin documentos. Añade tu primer documento arriba.",
    kb_filter_all: "Todos",
    kb_filter_policy: "Política",
    kb_new_doc: "+ Nuevo documento",
    kb_search_ph: "Buscar…",
    kb_label_title: "Título",
    kb_label_type: "Tipo de documento",
    kb_label_content: "Contenido (Markdown)",
    kb_modal_new: "Nuevo documento",
    kb_modal_edit: "Editar documento",
    kb_doc_create: "Crear",
    kb_status_embedded: "Indexado",
    kb_status_pending: "Pendiente",
    kb_status_outdated: "Obsoleto",
    kb_status_failed: "Fallido",
    kb_locked_content: "Contenido restringido",
    kb_locked_badge: "Protegido",
    kb_delete_title: "Eliminar documento",
    kb_delete_body: "Esta acción eliminará también los vectores Qdrant asociados.",
    kb_delete_confirm: "Eliminar",
    kb_delete_ok: "Documento eliminado.",
    kb_doc_save_ok: "¡Documento guardado!",
    stats_title: "Panel de <em>control</em>",
    stats_subtitle: "Actividad de tu chatbot",
    stat_requests: "Solicitudes",
    stat_sessions: "Sesiones",
    stat_cache_rate: "Tasa caché",
    stat_avg_latency: "Latencia media",
    stat_cost: "Coste estimado",
    stat_errors: "Errores",
    chart_requests: "Solicitudes / hora",
    chart_tokens: "Tokens",
    top_queries: "Top consultas",
    flush_cache: "Vaciar caché",
    recent_errors: "Errores recientes",
    clear_errors: "Borrar",
    clear_errors_ok: "Errores borrados.",
    clear_errors_err: "Error al borrar.",
    clear_errors_confirm: "¿Borrar todos los errores recientes?",
    clear_errors_title: "Borrar errores",
    settings_title: "Configura<em>ción</em>",
    settings_subtitle: "Personaliza tu chatbot",
    tab_widget: "Widget",
    tab_account: "Cuenta",
    tab_llm_key: "Clave API LLM",
    widget_appearance: "Apariencia",
    bot_name: "Nombre del bot",
    position: "Posición",
    pos_right: "Inferior derecha",
    pos_left: "Inferior izquierda",
    primary_color: "Color principal",
    secondary_color: "Color secundario",
    welcome_msg: "Mensaje de bienvenida",
    logo_url: "URL del logo",
    widget_icon_url: "URL ícono burbuja",
    widget_size: "Tamaño del widget",
    size_small: "Pequeño",
    size_medium: "Mediano",
    size_large: "Grande",
    widget_language: "Idioma del widget",
    placeholder_text: "Placeholder",
    powered_by_label: 'Mostrar "Powered by AM Solutions"',
    powered_by_desc: "Muestra un enlace sutil en la parte inferior del widget",
    business_info_title: "Información contextual",
    business_info_label: "Contexto para el bot",
    save_btn: "Guardar",
    saving: "Guardando…",
    saved: "¡Configuración guardada!",
    change_password: "Cambiar contraseña",
    current_password: "Contraseña actual",
    new_password: "Nueva contraseña",
    confirm_password: "Confirmar",
    pwd_mismatch: "Las contraseñas no coinciden.",
    pwd_too_short: "Mínimo 8 caracteres.",
    pwd_success: "¡Contraseña actualizada!",
    pwd_wrong: "La contraseña actual es incorrecta.",
    llm_key_title: "Clave API LLM",
    llm_key_desc: "Tu clave API para el modelo de lenguaje.",
    llm_key_not_set: "No configurada",
    llm_key_ok: "Configurada",
    llm_key_warning: "La clave será enmascarada al guardar. Guárdala en lugar seguro.",
    llm_key_new: "Nueva clave",
    llm_key_save: "Definir / Actualizar",
    llm_key_saved: "¡Clave API guardada!",
    integration_title: "Inte<em>gración</em>",
    integration_subtitle: "Integra el chatbot en tu sitio web",
    widget_key_title: "Clave widget",
    widget_key_desc: "Identificador público del widget.",
    widget_key_warning: "Para revelar la clave completa, confirme su contraseña.",
    reveal_password: "Contraseña",
    reveal_btn: "Revelar clave",
    reveal_key: "Revelar clave",
    reveal_wrong: "Contraseña incorrecta.",
    cancel: "Cancelar",
    copy: "Copiar",
    hide: "Ocultar",
    embed_code_title: "Código de integración",
    embed_code_desc: "Pega este código en el <head> de tu sitio.",
    copy_snippet: "Copiar código",
    copied: "¡Copiado!",
    powered_by_full: "Desarrollado por AM Solutions",
    widget_locked_notice: "La personalización del widget ha sido desactivada por su administrador de plataforma. Contacte a su administrador para activar esta función.",
    login_brand_sub: "Panel de control",
    login_h1_plain: "Analítica & Configuración",
    login_h1_em_target: "Configuración",
    login_subtitle: "Acceda a su espacio de gestión.",
    lbl_slug: "Identificador (slug)",
    lbl_password: "Contraseña",
    lbl_remember: "Mantener sesión",
    login_btn: "Iniciar sesión",
    pwd_show: "Mostrar contraseña",
    pwd_hide: "Ocultar contraseña",
    forgot_link: "¿Olvidó su contraseña?",
    forgot_title: "Recuperación de contraseña",
    forgot_desc: "Su contraseña está gestionada por <strong>AM Solutions</strong>, el administrador de la plataforma.<br><br>Para restablecerla, contacte al equipo de AM Solutions — recibirá un correo con sus nuevas credenciales.",
    forgot_back: "Volver",
    login_error: "Identificador o contraseña incorrectos.",
    session_expired: "Sesión expirada. Por favor, inicia sesión de nuevo.",
    error_generic: "Ocurrió un error.",
    period_24h: "24h",
    period_7d: "7d",
    period_30d: "30d",
    flush_ok: "¡Caché vaciada!",
    flush_err: "Error al vaciar caché.",
    theme_to_light: "Modo claro",
    theme_to_dark: "Modo oscuro",
    powered_by_readonly_note: "Este parámetro está reservado al administrador de plataforma.",
    preview_title: "Vista <em>previa</em>",
    preview_subtitle: "Tu widget tal como aparece en tu sitio",
    preview_reload: "Recargar",
    preview_open_tab: "Nueva pestaña",
  },
  de: {
    nav_stats: "Statistiken",
    nav_settings: "Einstellungen",
    nav_integration: "Integration",
    nav_kb: "Wissensdatenbank",
    nav_logout: "Abmelden",
    nav_preview: "Vorschau",
    kb_title: "<em>Wissens</em>datenbank",
    kb_subtitle: "Verwalten Sie die Dokumente und Informationen Ihres Assistenten.",
    kb_save: "Speichern",
    kb_stat_total: "Dokumente",
    kb_stat_embedded: "Indiziert",
    kb_stat_pending: "Ausstehend",
    kb_stat_failed: "Fehlgeschlagen",
    kb_wc_title: "WooCommerce-Synchronisation",
    kb_wc_desc: "Produkte von WooCommerce in die Wissensdatenbank synchronisieren.",
    kb_wc_btn: "Synchronisieren",
    kb_empty: "Keine Dokumente. Fügen Sie oben Ihr erstes Dokument hinzu.",
    kb_filter_all: "Alle",
    kb_filter_policy: "Richtlinie",
    kb_new_doc: "+ Neues Dokument",
    kb_search_ph: "Suchen…",
    kb_label_title: "Titel",
    kb_label_type: "Dokumenttyp",
    kb_label_content: "Inhalt (Markdown)",
    kb_modal_new: "Neues Dokument",
    kb_modal_edit: "Dokument bearbeiten",
    kb_doc_create: "Erstellen",
    kb_status_embedded: "Indiziert",
    kb_status_pending: "Ausstehend",
    kb_status_outdated: "Veraltet",
    kb_status_failed: "Fehlgeschlagen",
    kb_locked_content: "Eingeschränkter Inhalt",
    kb_locked_badge: "Geschützt",
    kb_delete_title: "Dokument löschen",
    kb_delete_body: "Diese Aktion entfernt auch die zugehörigen Qdrant-Vektoren.",
    kb_delete_confirm: "Löschen",
    kb_delete_ok: "Dokument gelöscht.",
    kb_doc_save_ok: "Dokument gespeichert!",
    stats_title: "Dash<em>board</em>",
    stats_subtitle: "Aktivität Ihres Chatbots",
    stat_requests: "Anfragen",
    stat_sessions: "Sitzungen",
    stat_cache_rate: "Cache-Rate",
    stat_avg_latency: "Durchschn. Latenz",
    stat_cost: "Geschätzte Kosten",
    stat_errors: "Fehler",
    chart_requests: "Anfragen / Stunde",
    chart_tokens: "Tokens",
    top_queries: "Top-Anfragen",
    flush_cache: "Cache leeren",
    recent_errors: "Letzte Fehler",
    clear_errors: "Löschen",
    clear_errors_ok: "Fehler gelöscht.",
    clear_errors_err: "Fehler beim Löschen.",
    clear_errors_confirm: "Alle letzten Fehler löschen?",
    clear_errors_title: "Fehler löschen",
    settings_title: "Einstel<em>lungen</em>",
    settings_subtitle: "Chatbot anpassen",
    tab_widget: "Widget",
    tab_account: "Konto",
    tab_llm_key: "LLM API-Schlüssel",
    widget_appearance: "Erscheinungsbild",
    bot_name: "Bot-Name",
    position: "Position",
    pos_right: "Unten rechts",
    pos_left: "Unten links",
    primary_color: "Primärfarbe",
    secondary_color: "Sekundärfarbe",
    welcome_msg: "Willkommensnachricht",
    logo_url: "Logo-URL",
    widget_icon_url: "Blasen-Symbol-URL",
    widget_size: "Widget-Größe",
    size_small: "Klein",
    size_medium: "Mittel",
    size_large: "Groß",
    widget_language: "Widget-Sprache",
    placeholder_text: "Platzhalter",
    powered_by_label: "«Powered by AM Solutions» anzeigen",
    powered_by_desc: "Zeigt einen diskreten Link am unteren Rand des Widgets",
    business_info_title: "Kontextinformationen",
    business_info_label: "Kontext für den Bot",
    save_btn: "Speichern",
    saving: "Wird gespeichert…",
    saved: "Einstellungen gespeichert!",
    change_password: "Passwort ändern",
    current_password: "Aktuelles Passwort",
    new_password: "Neues Passwort",
    confirm_password: "Bestätigen",
    pwd_mismatch: "Passwörter stimmen nicht überein.",
    pwd_too_short: "Mindestens 8 Zeichen.",
    pwd_success: "Passwort aktualisiert!",
    pwd_wrong: "Aktuelles Passwort ist falsch.",
    llm_key_title: "LLM API-Schlüssel",
    llm_key_desc: "Ihr API-Schlüssel für das Sprachmodell.",
    llm_key_not_set: "Nicht konfiguriert",
    llm_key_ok: "Konfiguriert",
    llm_key_warning: "Der Schlüssel wird nach dem Speichern maskiert. Bewahren Sie ihn sicher auf.",
    llm_key_new: "Neuer Schlüssel",
    llm_key_save: "Setzen / Aktualisieren",
    llm_key_saved: "API-Schlüssel gespeichert!",
    integration_title: "Inte<em>gration</em>",
    integration_subtitle: "Chatbot in Ihre Website einbetten",
    widget_key_title: "Widget-Schlüssel",
    widget_key_desc: "Öffentliche Widget-Kennung.",
    widget_key_warning: "Um den vollständigen Schlüssel anzuzeigen, bestätigen Sie Ihr Passwort.",
    reveal_password: "Passwort",
    reveal_btn: "Schlüssel enthüllen",
    reveal_key: "Schlüssel enthüllen",
    reveal_wrong: "Falsches Passwort.",
    cancel: "Abbrechen",
    copy: "Kopieren",
    hide: "Verbergen",
    embed_code_title: "Einbettungscode",
    embed_code_desc: "Fügen Sie diesen Code in den <head> Ihrer Website ein.",
    copy_snippet: "Code kopieren",
    copied: "Kopiert!",
    powered_by_full: "Unterstützt von AM Solutions",
    widget_locked_notice: "Die Widget-Anpassung wurde von Ihrem Plattformadministrator deaktiviert. Wenden Sie sich an Ihren Administrator, um diese Funktion zu aktivieren.",
    login_brand_sub: "Dashboard",
    login_h1_plain: "Analytik & Einstellungen",
    login_h1_em_target: "Einstellungen",
    login_subtitle: "Zugang zu Ihrem Verwaltungsbereich.",
    lbl_slug: "Kennung (Slug)",
    lbl_password: "Passwort",
    lbl_remember: "Angemeldet bleiben",
    login_btn: "Anmelden",
    pwd_show: "Passwort anzeigen",
    pwd_hide: "Passwort verbergen",
    forgot_link: "Passwort vergessen?",
    forgot_title: "Passwort zurücksetzen",
    forgot_desc: "Ihr Passwort wird von <strong>AM Solutions</strong>, dem Plattformadministrator, verwaltet.<br><br>Um es zurückzusetzen, wenden Sie sich an das AM Solutions-Team — Sie erhalten eine E-Mail mit Ihren neuen Zugangsdaten.",
    forgot_back: "Zurück",
    login_error: "Ungültige Kennung oder Passwort.",
    session_expired: "Sitzung abgelaufen. Bitte melden Sie sich erneut an.",
    error_generic: "Ein Fehler ist aufgetreten.",
    period_24h: "24h",
    period_7d: "7T",
    period_30d: "30T",
    flush_ok: "Cache geleert!",
    flush_err: "Fehler beim Leeren des Caches.",
    theme_to_light: "Hell-Modus",
    theme_to_dark: "Dunkel-Modus",
    powered_by_readonly_note: "Diese Einstellung ist dem Plattformadministrator vorbehalten.",
    preview_title: "Vor<em>schau</em>",
    preview_subtitle: "Ihr Widget, wie es auf Ihrer Website erscheint",
    preview_reload: "Neu laden",
    preview_open_tab: "Neuer Tab",
  },
};
